// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__TvxqG","spinner":"Loading_spinner__s5eU9","spin":"Loading_spin__sCrfu","message":"Loading_message__3DUsV"};